<template>
    <div class="content-page">
        <!-- pc端 -->
        <div class="pc-header">
            <div class="page-header">
                <crumbs></crumbs>
                <div class="header-actions">
                    <el-button type="primary" icon="el-icon-plus" class="add-btn" @click="handleAdd">新增发票报销</el-button>
                </div>
            </div>
            <div class="box filter-box">
                 <!-- 报销人 -->
                <CheckedSelect v-model="form.userId" :options="salePersonOption" label="报销人" @change="updateList" />
                <!-- 报销类型 -->
                <CheckedSelect v-model="form.invoiceTypeList" :options="[{id:'',name:'全部'}, ...invoiceTypeOptions]" label="报销类型" :props="{multi:true}" @change="updateList" />
                <!-- 是否关联拜访 -->
                <CheckedSelect v-model="form.hasVisit" :options="[{id:'',name:'全部'},{id:1,name:'已关联'},{id:0,name:'未关联'}]" label="关联拜访" @change="updateList" />
                <!-- 分割线 -->
                <div class="filter-divider"></div>
                <!-- 发生日期、排序、导入导出 同一行 -->
                <div class="filter-line filter-line-row">
                    <div class="filter-date-wrap">
                        <div class="title-name">发生日期：</div>
                        <div class="filter-date-box">
                            <el-date-picker style="width: 100%" v-model="form.invoiceDateStart" type="date" placeholder="开始时间" value-format="yyyy-MM-dd" @change="updateList">
                            </el-date-picker>
                            <span>-</span>
                            <el-date-picker style="width: 100%" v-model="form.invoiceDateEnd" type="date" placeholder="结束时间" value-format="yyyy-MM-dd" @change="updateList">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="filter-sort-wrap">
                        <div class="title-name">排序：</div>
                        <div class="filter-item-box">
                            <el-radio-group v-model="form.sortType" @change="updateList">
                                <el-radio :label="0">发生日期最早</el-radio>
                                <el-radio :label="1">发生日期最晚</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="export-box">
                        <el-button type="primary" icon="el-icon-upload2" :loading="loadImport" @click="showImportDialog = true">导入列表</el-button>
                        <el-button type="primary" icon="el-icon-download" :loading="loadExport" @click="exportData">导出列表</el-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 手机端 -->
        <div class="mobile-header">
            <div class="top-bar">
                <expandMenuIcon></expandMenuIcon>
                <span class="page-title">发票报销</span>
                <div class="add-user-box" @click="handleAdd">
                    <i class="el-icon-plus add-user"></i>
                </div>
            </div>
            <div class="filter-line">
                <div class="filter" @click="showMobileFilter = true">
                    <span>筛选</span>
                    <i class="el-icon-caret-bottom"></i>
                </div>
            </div>
        </div>

        <!-- 统计区域：环形图 + 明细 -->
        <div class="stats-panel">
            <div class="stats-chart-box">
                <div ref="statsChart" class="stats-chart"></div>
                <div class="stats-chart-center">
                    <div class="chart-center-label">报销总金额</div>
                    <div class="chart-center-value">¥{{ formatAmount(totalAmount) }}</div>
                    <div class="chart-center-sub">{{ total || 0 }} 条记录</div>
                </div>
            </div>
            <div class="stats-detail">
                <div class="stats-detail-item" v-for="typeId in [1, 2, 4, 6, 5]" :key="'stat-' + typeId">
                    <div class="detail-left">
                        <span class="detail-dot" :class="'dot-type-' + typeId"></span>
                        <span class="detail-name">{{ getInvoiceTypeName(typeId) }}</span>
                    </div>
                    <div class="detail-right">
                        <span class="detail-count">{{ typeStat(typeId).count }}条</span>
                        <span class="detail-amount">¥{{ formatAmount(typeStat(typeId).amount) }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 卡片列表 -->
        <div class="card-list">
            <div class="card-item" v-for="item in invoiceList" :key="item.id" @click="handleDetail(item)" :class="'type-' + item.invoiceType">
                <!-- 顶部：左图标+类型 + 右状态+更多 -->
                <div class="card-head">
                    <div class="card-head-left">
                        <div class="card-icon" :class="'icon-type-' + item.invoiceType">
                            <i :class="getTypeIcon(item.invoiceType)"></i>
                        </div>
                        <span class="type-name">{{ getInvoiceTypeName(item.invoiceType) }}</span>
                    </div>
                    <div class="card-head-right">
                        <span class="status-tag" :class="{ linked: item.visitLogCount > 0 }">
                            {{ item.visitLogCount > 0 ? '关联拜访' + item.visitLogCount + '次' : '未关联' }}
                        </span>
                        <div class="card-more" @click.stop v-if="canEdit(item)">
                            <el-popover placement="bottom-end" :trigger="$utils.isMobile() ? 'click' : 'hover'" popper-class="my-pop">
                                <ul class="corner-operation">
                                    <li @click="handleEdit(item)"><i class="el-icon-edit"></i>编辑</li>
                                    <li class="del-li" @click="handleDelete(item)"><i class="el-icon-delete"></i>删除</li>
                                </ul>
                                <i slot="reference" class="el-icon-more more-icon"></i>
                            </el-popover>
                        </div>
                    </div>
                </div>
                <!-- 金额 -->
                <div class="card-amount">
                    <span class="currency">¥</span><span class="num">{{ formatAmount(item.amount) }}</span>
                </div>
                <!-- 备注 -->
                <div class="card-remark" v-if="item.remark">{{ item.remark }}</div>
                <div class="card-remark empty" v-else>暂无备注</div>
                <!-- 底部：报销人 + 日期 -->
                <div class="card-foot">
                    <div class="foot-user">
                        <span class="user-avatar">{{ (item.userName || '').substring(0,1) }}</span>
                        <span class="user-name">{{ item.userName }}</span>
                    </div>
                    <div class="foot-date">
                        <i class="el-icon-date"></i>
                        <span>{{ item.invoiceDate }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="loading && $utils.isMobile()" class="load-text">正在加载中...</div>
        <!-- 空数据 -->
        <div class="empty-wrap" v-if="total === 0 && !loading">
            <img src="@/assets/image/emptyBlue.png" alt="">
        </div>

        <pagination v-show="total && !$utils.isMobile()" :total="total" :page.sync="form.currentPage" :limit.sync="form.limit" :pageSizes="[6, 12, 24, 48]" @pagination="findPageApi" />

        <!-- 手机端筛选 -->
        <filterDrawer :showMobileFilter.sync="showMobileFilter" :form="form" @confirm="handleConfirm">
        </filterDrawer>

        <!-- 新增、编辑报销 -->
        <addInvoiceDrawer :drawer.sync="addDrawer" :itemId="addDrawerId" @updateList="handleAddUpdate"></addInvoiceDrawer>

        <!-- 报销详情 -->
        <invoiceDetailDrawer :drawer.sync="detailDrawer" :itemId="detailDrawerId"></invoiceDetailDrawer>

        <!-- 导入弹窗 -->
        <el-dialog :visible.sync="showImportDialog" width="600px" :show-close="false" custom-class="import-dialog" :close-on-click-modal="false">
            <div class="import-content">
                <!-- 头部 -->
                <div class="import-header">
                    <div class="import-title">
                        <div class="title-icon">
                            <i class="el-icon-folder-add"></i>
                        </div>
                        <div>
                            <div class="title-main">导入发票报销</div>
                            <div class="title-sub">快速批量导入发票数据，提升录入效率</div>
                        </div>
                    </div>
                    <i class="el-icon-close dialog-close" @click="showImportDialog = false"></i>
                </div>

                <!-- 步骤1：下载模板 -->
                <div class="import-step">
                    <div class="step-head">
                        <span class="step-num">1</span>
                        <span class="step-label">下载导入模板</span>
                        <span class="step-desc">获取标准格式的Excel模板</span>
                    </div>
                    <div class="template-card" @click="downloadTemplate">
                        <div class="template-icon">
                            <i class="el-icon-document"></i>
                        </div>
                        <div class="template-info">
                            <div class="template-name">发票报销导入模板.xlsx</div>
                            <div class="template-meta">
                                <span><i class="el-icon-date"></i> 最新格式</span>
                                <span><i class="el-icon-setting"></i> 5列字段</span>
                            </div>
                        </div>
                        <div class="template-action">
                            <i class="el-icon-download"></i>
                            <span>下载</span>
                        </div>
                    </div>
                </div>

                <!-- 步骤分割线 -->
                <div class="step-divider">
                    <span class="divider-ornament"></span>
                    <span class="divider-text">完成后进入下一步</span>
                    <span class="divider-ornament"></span>
                </div>

                <!-- 步骤2：上传文件 -->
                <div class="import-step">
                    <div class="step-head">
                        <span class="step-num">2</span>
                        <span class="step-label">上传填写好的文件</span>
                        <span class="step-desc">拖拽或点击选择Excel文件</span>
                    </div>
                    <el-upload
                        ref="importUpload"
                        action="#"
                        :auto-upload="false"
                        :limit="1"
                        accept=".xlsx,.xls"
                        :on-change="handleImportFileChange"
                        :on-remove="handleImportFileRemove"
                        :file-list="importFileList"
                        :show-file-list="false"
                        drag
                        class="upload-dragger-wrap">
                        <div class="upload-zone">
                            <div class="upload-icon-wrap">
                                <i class="el-icon-upload2 upload-icon"></i>
                                <div class="upload-icon-glow"></div>
                            </div>
                            <div class="upload-text">
                                <span v-if="!importFile">将文件拖到此处，或</span>
                                <span class="upload-link" v-if="!importFile">点击选择文件</span>
                                <template v-else>
                                    <i class="el-icon-check-circle upload-success-icon"></i>
                                    <span class="upload-success-text">已选择文件</span>
                                </template>
                            </div>
                            <div class="upload-name" v-if="importFile">
                                {{ importFile.name }}
                                <i class="el-icon-close upload-remove" @click.stop="removeSelectedFile"></i>
                            </div>
                            <div class="upload-tip" v-if="!importFile">
                                <i class="el-icon-warning-outline"></i>
                                仅支持 <b>.xlsx</b> / <b>.xls</b> 格式，文件大小不超过 20MB
                            </div>
                        </div>
                    </el-upload>
                </div>

                <!-- 底部注意事项 -->
                <div class="import-notice">
                    <i class="el-icon-info"></i>
                    <span>关联拜访和发票附件无法批量导入，需在<b>新增/编辑</b>发票时单独上传处理。</span>
                </div>

                <!-- 底部按钮 -->
                <div class="import-footer">
                    <div class="footer-btn cancel-btn" @click="showImportDialog = false">取消</div>
                    <div class="footer-btn confirm-btn" :class="{ disabled: !importFile, loading: loadImport }" @click="confirmImport">
                        <i class="el-icon-loading" v-if="loadImport"></i>
                        <span v-if="loadImport">导入中...</span>
                        <span v-else>确认导入</span>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import addInvoiceDrawer from "./components/addInvoiceDrawer.vue";
import invoiceDetailDrawer from "./components/invoiceDetailDrawer.vue";
import filterDrawer from "./components/filterDrawer.vue";
import { findAllInvoicePage, downloadAllInvoiceList, deleteInvoice, importInvoiceList, downloadImportTemplate } from "@/api/invoice/index.js";

import { mapState } from "vuex";
export default {
    components: {
        addInvoiceDrawer,
        invoiceDetailDrawer,
        filterDrawer,
    },
    data() {
        return {
            showMobileFilter: false,
            form: {
                invoiceTypeList: [],
                userId: "",
                hasVisit: "",
                invoiceDateStart: "",
                invoiceDateEnd: "",
                sortType: 1,
                currentPage: 1,
                limit: 6,
            },
            invoiceList: [],
            total: 0,
            totalAmount: 0,
            typeStatList: [],
            loading: false,
            addDrawer: false,
            addDrawerId: "",
            detailDrawer: false,
            detailDrawerId: "",
            loadExport: false,
            // ECharts实例
            chartInstance: null,
            // 导入相关
            showImportDialog: false,
            loadImport: false,
            importFileList: [],
            importFile: null,
            // 报销类型：1-住宿费 2-交通费 3-餐饮 4-业务
            invoiceTypeOptions: [
                { id: 1, name: "住宿费" },
                { id: 2, name: "交通费" },
                { id: 4, name: "客户维护费" },
                { id: 6, name: "服务费" },
                { id: 5, name: "其他" },
            ],
        };
    },
    computed: {
        ...mapState(["userData", "salePersonOption"]),
        // 获取指定类型的统计（记录数、金额）
        typeStat() {
            return (typeId) => {
                let item = this.typeStatList.find((s) => s.invoiceType === typeId);
                return {
                    count: item ? item.count : 0,
                    amount: item ? item.amount : 0,
                };
            };
        },
    },
    created() {
        this.findPageApi();
        if (this.$utils.isMobile()) {
            window.addEventListener("scroll", () => {
                this.handleScroll();
            });
        }
    },
    mounted() {
        window.addEventListener("resize", this.handleChartResize);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", () => {
            this.handleScroll();
        });
        window.removeEventListener("resize", this.handleChartResize);
        if (this.chartInstance) {
            this.chartInstance.dispose();
            this.chartInstance = null;
        }
    },
    methods: {
        // 报销类型名称
        getInvoiceTypeName(type) {
            let map = { 1: "住宿费", 2: "交通费", 4: "客户维护费", 6: "服务费", 5: "其他"};
            return map[type] || "--";
        },
        // 报销类型图标
        getTypeIcon(type) {
            let map = { 1: "el-icon-s-home", 2: "el-icon-truck", 4: "el-icon-office-building", 6: "el-icon-coin", 5: "el-icon-tickets" };
            return map[type] || "el-icon-tickets";
        },
        // 格式化金额（保留2位小数）
        formatAmount(val) {
            if (val == null) return '0.00';
            let num = Number(val);
            return num.toFixed(2);
        },
        // 是否可编辑删除
        canEdit() {
            return true;
        },
        // 更新环形图
        updateChart() {
            if (!this.$refs.statsChart) return;
            const typeColors = { 1: "#f97316", 2: "#3b82f6", 4: "#22c55e", 6: "#a855f7", 5: "#64748b" };
            let chartData = [1, 2, 4, 6, 5].map((typeId) => {
                let stat = this.typeStat(typeId);
                return {
                    name: this.getInvoiceTypeName(typeId),
                    value: parseFloat(stat.amount) || 0,
                    count: stat.count,
                    itemStyle: { color: typeColors[typeId] },
                };
            }).filter((d) => d.value > 0);
            if (chartData.length === 0) {
                chartData = [{ value: 1, itemStyle: { color: "#f0f2f5" }, name: "暂无数据" }];
            }
            if (!this.chartInstance) {
                this.chartInstance = this.$echarts.init(this.$refs.statsChart);
            }
            this.chartInstance.setOption({
                tooltip: {
                    trigger: "item",
                    formatter: (p) => `${p.data.name}<br/>¥${this.formatAmount(p.value)}（${p.percent}%）<br/>${p.data.count || 0}条`,
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    borderColor: '#e2e8f0',
                    textStyle: { color: '#334155' },
                    extraCssText: 'box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1); border-radius: 8px;'
                },
                series: [{
                    type: "pie",
                    radius: ["65%", "85%"],
                    center: ["50%", "50%"],
                    avoidLabelOverlap: false,
                    label: { show: false },
                    labelLine: { show: false },
                    itemStyle: {
                        borderRadius: 4,
                        borderColor: "#fff",
                        borderWidth: 2,
                    },
                    data: chartData,
                }],
            }, true);
        },
        // 图表resize
        handleChartResize() {
            if (this.chartInstance) {
                this.chartInstance.resize();
            }
        },
        // 新增报销
        handleAdd() {
            this.addDrawer = true;
            this.addDrawerId = "";
        },
        // 编辑
        handleEdit(row) {
            this.addDrawer = true;
            this.addDrawerId = row.id;
        },
        // 查看详情
        handleDetail(row) {
            this.detailDrawer = true;
            this.detailDrawerId = row.id;
        },
        // 新增/编辑成功回调
        handleAddUpdate() {
            this.updateList();
        },
        // 删除
        handleDelete(row) {
            this.$MessageBox.MesssageBoxQuestion("确认删除该发票报销记录？删除后不可恢复。")
                .then(() => {
                    deleteInvoice({ id: row.id })
                        .then(() => {
                            this.$MessageBox.MessageSuccess("删除成功");
                            // 删除当前页最后一条时回到上一页
                            if (this.invoiceList.length === 1 && this.form.currentPage > 1) {
                                this.form.currentPage -= 1;
                            }
                            this.findPageApi();
                        })
                        .catch((err) => {
                            this.$MessageBox.MessageWarning(err.data.msg);
                        });
                })
                .catch(() => {});
        },
        // 手机端筛选确认
        handleConfirm(param) {
            this.form = param;
            this.updateList();
        },
        // 当前页变化
        updateList() {
            this.form.currentPage = 1;
            this.findPageApi();
        },
        // 分页查询
        findPageApi(flag) {
            let request = findAllInvoicePage;
            // 清理空字符串参数，避免后端Integer/Long接收空串报错
            let params = { ...this.form };
            if (params.hasVisit === '' || params.hasVisit === null) {
                delete params.hasVisit;
            }
            if (params.userId === '' || params.userId === null) {
                delete params.userId;
            }
            request(params)
                .then((res) => {
                    this.loading = false;
                    this.total = res.count;
                    this.totalAmount = res.totalAmount || 0;
                    this.typeStatList = res.typeStatList || [];
                    let list = res.data?.list || res.data || [];
                    if (flag == "scroll") {
                        this.invoiceList.push(...list);
                    } else {
                        this.invoiceList = list;
                    }
                    this.$nextTick(() => this.updateChart());
                })
                .catch((err) => {
                    if (err.status === 888) return;
                    this.loading = false;
                    this.total = 0;
                    this.invoiceList = [];
                    if (err.status !== 200) {
                        this.$MessageBox.MessageWarning(err.data?.msg);
                    }
                });
        },
        // 处理滚动事件
        handleScroll() {
            if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight) {
                this.loadMoreData();
            }
        },
        // 加载更多数据
        loadMoreData() {
            if (this.loading) return;
            if (this.invoiceList.length >= this.total) {
                return;
            }
            this.loading = true;
            setTimeout(() => {
                this.form.currentPage += 1;
                this.findPageApi("scroll");
            }, 1000);
        },
        // 点击导出
        exportData() {
            this.loadExport = true;
            let params = { ...this.form };
            delete params.limit;
            delete params.currentPage;
            if (params.hasVisit === '' || params.hasVisit === null) delete params.hasVisit;
            if (params.userId === '' || params.userId === null) delete params.userId;
            downloadAllInvoiceList(params).then(res => {
                if (res.data.type === "application/json") {
                    let blobReader = new Response(res.data).json();
                    blobReader.then((item) => {
                        this.$MessageBox.MessageWarning(item.msg);
                        this.loadExport = false;
                    });
                } else {
                    this.$utils.download(res);
                    this.loadExport = false;
                }
            }).catch(err => {
                this.loadExport = false;
                this.$MessageBox.MessageWarning(err.data?.msg);
            });
        },
        // 下载导入模板
        downloadTemplate() {
            downloadImportTemplate().then(res => {
                if (res.data.type === "application/json") {
                    let blobReader = new Response(res.data).json();
                    blobReader.then((item) => {
                        this.$MessageBox.MessageWarning(item.msg);
                    });
                } else {
                    this.$utils.download(res);
                }
            }).catch(err => {
                this.$MessageBox.MessageWarning(err.data?.msg);
            });
        },
        // 导入文件选择
        handleImportFileChange(file) {
            this.importFile = file.raw;
        },
        // 导入文件移除
        handleImportFileRemove() {
            this.importFile = null;
        },
        // 手动移除已选文件
        removeSelectedFile() {
            this.importFile = null;
            this.importFileList = [];
            this.$refs.importUpload && this.$refs.importUpload.clearFiles();
        },
        // 确认导入
        confirmImport() {
            if (!this.importFile) {
                this.$MessageBox.MessageWarning("请先选择要导入的文件");
                return;
            }
            this.loadImport = true;
            let formData = new FormData();
            formData.append("file", this.importFile);
            importInvoiceList(formData).then(res => {
                this.loadImport = false;
                if (res.success) {
                    this.$MessageBox.MessageSuccess(res.data || "导入成功");
                    this.showImportDialog = false;
                    this.importFile = null;
                    this.importFileList = [];
                    this.form.currentPage = 1;
                    this.findPageApi();
                } else {
                    this.$MessageBox.MessageWarning(res.data || res.msg || "导入失败");
                }
            }).catch(err => {
                this.loadImport = false;
                this.$MessageBox.MessageWarning(err.data?.msg || "导入失败");
            });
        },
    },
};
</script>
<style lang="scss" scoped>
/*pc端*/
@media only screen and (min-width: 768px) {
    .content-page {
        width: 80%;
        margin: 0 auto;
        padding-top: $pc-header-height;
        min-height: calc(100vh - #{$pc-header-height});
        padding-bottom: 4rem;
        .mobile-header {
            display: none;
        }
        .add-btn {
            border-radius: 0.8rem;
        }
        .page-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 16px 0 16px;
            /deep/ .crumbs-box {
                margin: 0;
            }
        }
        .header-actions {
            display: flex;
        }
        .box {
            background-color: #fff;
            box-shadow: 0px 1px 6px 1px rgba(4, 32, 93, 0.06);
            border-radius: 12px;
        }
        .filter-box {
            position: relative;
            margin: 16px 0 12px;
            padding: 20px 1.38rem;
            .filter-divider {
                height: 1px;
                background: #f1f5f9;
                margin: 14px 0;
            }
            /deep/ .filter-line {
                display: flex;
                &:not(:last-of-type) {
                    margin-bottom: 8px;
                }
                .title-name {
                    min-width: 6rem;
                    padding-top: 5px;
                    white-space: nowrap;
                }
                .filter-date-box {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    > .el-input {
                        .el-input__inner {
                            width: 9rem;
                            height: 2rem;
                            padding-left: 2.2rem;
                            border-color: #e2e8f0;
                            border-radius: 8px;
                            font-size: 0.8rem;
                            color: #475569;
                            transition: all 0.2s;
                            &:hover { border-color: #cbd5e1; }
                            &:focus { border-color: #3b82f6; }
                        }
                        .el-input__prefix {
                            left: 0.6rem;
                            .el-input__icon {
                                line-height: 2rem;
                                font-size: 0.85rem;
                                color: #94a3b8;
                            }
                        }
                    }
                }
                &.filter-line-row {
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 0 32px;
                    margin-bottom: 0;
                    .filter-date-wrap,
                    .filter-sort-wrap {
                        display: flex;
                        align-items: center;
                    }
                    .filter-date-wrap .title-name,
                    .filter-sort-wrap .title-name {
                        min-width: auto;
                        padding-top: 0;
                        margin-right: 8px;
                        font-size: 0.82rem;
                        color: #64748b;
                        font-weight: 500;
                    }
                    .filter-sort-wrap {
                        .filter-item-box {
                            .el-radio-group {
                                display: flex;
                                align-items: center;
                                gap: 20px;
                            }
                        }
                    }
                    .export-box {
                        margin-left: auto;
                        display: flex;
                        gap: 8px;
                    }
                }
            }
            .export-box {
                > .el-button {
                    border-radius: 8px;
                    background: #f8fafc;
                    border: 1px solid #e2e8f0;
                    color: #475569;
                    font-weight: 500;
                    transition: all 0.2s;
                    &:hover {
                        background: #f1f5f9;
                        border-color: #cbd5e1;
                        color: #334155;
                    }
                    i { font-weight: 600; }
                }
            }
            /deep/ .filter-item-box {
                .el-radio {
                    .el-radio__label {
                        font-size: 0.8rem;
                        color: #64748b;
                        transition: all 0.2s;
                    }
                    .el-radio__input.is-checked + .el-radio__label {
                        color: #3b82f6;
                        font-weight: 600;
                    }
                    .el-radio__input.is-checked .el-radio__inner {
                        background-color: #3b82f6;
                        border-color: #3b82f6;
                    }
                }
            }
        }
        /* ========== 统计区域：环形图 + 明细 ========== */
        .stats-panel {
            display: flex;
            align-items: center;
            gap: 32px;
            padding: 24px;
            margin-bottom: 14px;
            background: #fff;
            border-radius: 12px;
            border: 1px solid #f1f5f9;
            box-shadow: 0 1px 3px rgba(0,0,0,0.04);
            .stats-chart-box {
                position: relative;
                width: 224px;
                height: 224px;
                flex-shrink: 0;
                .stats-chart { width: 100%; height: 100%; }
                .stats-chart-center {
                    position: absolute;
                    top: 50%; left: 50%;
                    transform: translate(-50%, -50%);
                    text-align: center;
                    pointer-events: none;
                    .chart-center-label {
                        font-size: 10px;
                        color: #94a3b8;
                        font-weight: 500;
                        margin-bottom: 4px;
                        text-transform: uppercase;
                        letter-spacing: 0.05em;
                    }
                    .chart-center-value {
                        font-size: 1.25rem;
                        font-weight: 700;
                        color: #1e293b;
                        line-height: 1;
                    }
                    .chart-center-sub {
                        font-size: 11px;
                        color: #94a3b8;
                        margin-top: 6px;
                        background: #f8fafc;
                        padding: 2px 8px;
                        border-radius: 9999px;
                        border: 1px solid #f1f5f9;
                        display: inline-block;
                    }
                }
            }
            .stats-detail {
                flex: 1;
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 0 32px;
                .stats-detail-item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 18px 8px;
                    border-bottom: 1px solid #f1f5f9;
                    transition: background 0.2s;
                    border-radius: 8px;
                    &:hover { background: #f8fafc; }
                    &:nth-last-child(-n+2) { border-bottom: none; }
                    .detail-left {
                        display: flex;
                        align-items: center;
                        gap: 12px;
                    }
                    .detail-dot {
                        width: 12px; height: 12px;
                        border-radius: 50%;
                        flex-shrink: 0;
                        box-shadow: 0 1px 2px rgba(0,0,0,0.1);
                        &.dot-type-1 { background: #f97316; }
                        &.dot-type-2 { background: #3b82f6; }
                        &.dot-type-4 { background: #22c55e; }
                        &.dot-type-6 { background: #a855f7; }
                        &.dot-type-5 { background: #64748b; }
                    }
                    .detail-name {
                        font-size: 0.875rem;
                        color: #475569;
                        font-weight: 500;
                    }
                    .detail-right {
                        display: flex;
                        align-items: center;
                        gap: 16px;
                    }
                    .detail-count {
                        font-size: 0.875rem;
                        color: #94a3b8;
                        width: 48px;
                        text-align: right;
                    }
                    .detail-amount {
                        font-size: 0.875rem;
                        font-weight: 600;
                        color: #1e293b;
                        width: 96px;
                        text-align: right;
                        font-variant-numeric: tabular-nums;
                    }
                }
            }
        }
        .card-list {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 16px;
            .card-item {
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                min-height: 190px;
                background: #fff;
                border-radius: 12px;
                border: 1px solid #f1f5f9;
                box-shadow: 0 1px 3px rgba(0,0,0,0.04);
                padding: 20px;
                cursor: pointer;
                transition: all 0.3s cubic-bezier(0.4,0,0.2,1);
                overflow: hidden;
                &:hover {
                    border-color: #e2e8f0;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
                    transform: translateY(-2px);
                }
                .card-head {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 10px;
                    .card-head-left {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                    }
                    .card-icon {
                        width: 40px;
                        height: 40px;
                        border-radius: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;
                        border: 1px solid #f1f5f9;
                        transition: transform 0.3s cubic-bezier(0.4,0,0.2,1);
                        i {
                            font-size: 20px;
                        }
                        &.icon-type-1 { background: #fff7ed; i { color: #f97316; } }
                        &.icon-type-2 { background: #eff6ff; i { color: #3b82f6; } }
                        &.icon-type-4 { background: #f0fdf4; i { color: #22c55e; } }
                        &.icon-type-6 { background: #faf5ff; i { color: #a855f7; } }
                        &.icon-type-5 { background: #f8fafc; i { color: #64748b; } }
                    }
                    .type-name {
                        font-size: 1.05rem;
                        font-weight: 600;
                        color: #334155;
                    }
                    .card-head-right {
                        display: flex;
                        align-items: center;
                        gap: 6px;
                        .status-tag {
                            display: inline-block;
                            padding: 3px 10px;
                            border-radius: 9999px;
                            font-size: 0.76rem;
                            font-weight: 500;
                            background: #f8fafc;
                            color: #64748b;
                            border: 1px solid #e2e8f0;
                            transition: all 0.2s;
                            &.linked {
                                background: #eff6ff;
                                color: #3b82f6;
                                border: 1px solid #bfdbfe;
                            }
                        }
                    }
                }
                &:hover .card-icon {
                    transform: scale(1.06);
                }
                .card-more {
                    .more-icon {
                        font-size: 1.1rem;
                        color: #94a3b8;
                        cursor: pointer;
                        padding: 4px;
                        border-radius: 6px;
                        transition: all 0.2s;
                        &:hover { color: #3b82f6; background: #eff6ff; }
                    }
                }
                .card-amount {
                    display: flex;
                    align-items: baseline;
                    margin-bottom: 4px;
                    .currency {
                        font-size: 1.125rem;
                        font-weight: 500;
                        color: #94a3b8;
                        margin-right: 2px;
                    }
                    .num {
                        font-size: 1.875rem;
                        font-weight: 700;
                        color: #1e293b;
                        letter-spacing: -0.5px;
                        font-variant-numeric: tabular-nums;
                        line-height: 1.15;
                    }
                }
                .card-remark {
                    font-size: 13px;
                    color: #64748b;
                    line-height: 1.5;
                    margin-bottom: 12px;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    min-height: 2.4rem;
                    &.empty {
                        color: #cbd5e0;
                        font-style: italic;
                        min-height: auto;
                        margin-bottom: 16px;
                    }
                }
                .card-foot {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-top: 10px;
                    border-top: 1px solid #f1f5f9;
                    margin-top: auto;
                    .foot-user {
                        display: flex;
                        align-items: center;
                        gap: 6px;
                        .user-avatar {
                            width: 24px;
                            height: 24px;
                            border-radius: 50%;
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 0.72rem;
                            font-weight: 600;
                            color: #fff;
                            background: #0440c3;
                        }
                        .user-name {
                            font-size: 0.82rem;
                            color: #475569;
                            font-weight: 500;
                        }
                    }
                    .foot-date {
                        display: flex;
                        align-items: center;
                        gap: 3px;
                        font-size: 0.75rem;
                        color: #94a3b8;
                        i { font-size: 0.8rem; }
                    }
                }
            }
        }
        @media (max-width: 1200px) {
            .card-list {
                grid-template-columns: repeat(2, 1fr);
            }
        }
        @media (max-width: 900px) {
            .card-list {
                grid-template-columns: repeat(2, 1fr);
                gap: 12px;
            }
        }
    }
    .empty-wrap {
        padding-top: 50px;
        text-align: center;
        > img {
            width: 460px;
        }
    }
    .load-text {
        display: none;
    }
    .pagination-container {
        margin-top: 2rem;
        text-align: right;
    }
}

/*移动端*/
@media only screen and (max-width: 767px) {
    .content-page {
        padding: 0 13px 40px;
        background-color: #f4f6fd;
        min-height: 100vh;
        .pc-header {
            display: none;
        }
        .top-bar {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 999;
            background-color: #fff;
            height: 3.9rem;
            border-radius: 0 0 20px 20px;
            box-shadow: 0px 1px 12px 1px rgba(9, 16, 92, 0.08);
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 1rem;
            .page-title {
                font-size: 1.14rem;
                font-weight: 550;
                color: $primary-font-color;
            }
            .add-user-box {
                width: 1.5rem;
                height: 1.5rem;
                border: 1px solid $primary-font-color;
                border-radius: 50%;
                @include bothCenter;
                .add-user {
                    font-weight: 550;
                    font-size: 1rem;
                }
            }
        }
        .filter-line {
            margin: 4.5rem 0 1rem;
            display: flex;
            font-size: 0.86rem;
            font-weight: 550;
            .filter {
                flex: 1;
                border-radius: 12px;
                background-color: #fff;
                box-shadow: 0px 1px 6px 1px rgba(1, 27, 98, 0.05);
                @include bothCenter;
                padding: 0.6rem 0;
                i {
                    margin-left: 4px;
                }
            }
        }
        /* ========== 统计区域 - 移动端 ========== */
        .stats-panel {
            display: flex;
            flex-direction: column;
            gap: 16px;
            padding: 16px;
            margin-bottom: 10px;
            background: #fff;
            border-radius: 12px;
            border: 1px solid #f1f5f9;
            box-shadow: 0 1px 3px rgba(0,0,0,0.04);
            .stats-chart-box {
                position: relative;
                width: 140px;
                height: 140px;
                flex-shrink: 0;
                margin: 0 auto;
                .stats-chart { width: 100%; height: 100%; }
                .stats-chart-center {
                    position: absolute;
                    top: 50%; left: 50%;
                    transform: translate(-50%, -50%);
                    text-align: center;
                    pointer-events: none;
                    .chart-center-label {
                        font-size: 9px;
                        color: #94a3b8;
                        font-weight: 500;
                        margin-bottom: 2px;
                        text-transform: uppercase;
                        letter-spacing: 0.05em;
                    }
                    .chart-center-value {
                        font-size: 1rem;
                        font-weight: 700;
                        color: #1e293b;
                        line-height: 1;
                    }
                    .chart-center-sub {
                        font-size: 10px;
                        color: #94a3b8;
                        margin-top: 4px;
                        background: #f8fafc;
                        padding: 1px 6px;
                        border-radius: 9999px;
                        border: 1px solid #f1f5f9;
                        display: inline-block;
                    }
                }
            }
            .stats-detail {
                display: grid;
                grid-template-columns: 1fr;
                gap: 0;
                width: 100%;
                .stats-detail-item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 12px 6px;
                    border-bottom: 1px solid #f8fafc;
                    &:last-child { border-bottom: none; }
                    .detail-left {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                    }
                    .detail-dot {
                        width: 10px; height: 10px;
                        border-radius: 50%;
                        flex-shrink: 0;
                        &.dot-type-1 { background: #f97316; }
                        &.dot-type-2 { background: #3b82f6; }
                        &.dot-type-4 { background: #22c55e; }
                        &.dot-type-6 { background: #a855f7; }
                        &.dot-type-5 { background: #64748b; }
                    }
                    .detail-name {
                        font-size: 0.82rem;
                        color: #475569;
                        font-weight: 500;
                    }
                    .detail-right {
                        display: flex;
                        align-items: center;
                        gap: 12px;
                    }
                    .detail-count {
                        font-size: 0.78rem;
                        color: #94a3b8;
                        width: 40px;
                        text-align: right;
                    }
                    .detail-amount {
                        font-size: 0.82rem;
                        font-weight: 600;
                        color: #1e293b;
                        width: 80px;
                        text-align: right;
                        font-variant-numeric: tabular-nums;
                    }
                }
            }
        }
        .card-list {
            display: flex;
            flex-direction: column;
            gap: 10px;
            .card-item {
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                min-height: 170px;
                background-color: #fff;
                border-radius: 12px;
                border: 1px solid #f1f5f9;
                box-shadow: 0 1px 3px rgba(0,0,0,0.04);
                padding: 16px;
                cursor: pointer;
                transition: all 0.2s ease;
                overflow: hidden;
                &:active {
                    transform: scale(0.98);
                    border-color: #e2e8f0;
                }
                .card-head {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 8px;
                    .card-head-left {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                    }
                    .card-icon {
                        width: 36px;
                        height: 36px;
                        border-radius: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;
                        border: 1px solid #f1f5f9;
                        i {
                            font-size: 18px;
                        }
                        &.icon-type-1 { background: #fff7ed; i { color: #f97316; } }
                        &.icon-type-2 { background: #eff6ff; i { color: #3b82f6; } }
                        &.icon-type-4 { background: #f0fdf4; i { color: #22c55e; } }
                        &.icon-type-6 { background: #faf5ff; i { color: #a855f7; } }
                        &.icon-type-5 { background: #f8fafc; i { color: #64748b; } }
                    }
                    .type-name {
                        font-size: 0.95rem;
                        font-weight: 600;
                        color: #334155;
                    }
                    .card-head-right {
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        .status-tag {
                            display: inline-block;
                            padding: 2px 9px;
                            border-radius: 9999px;
                            font-size: 0.7rem;
                            font-weight: 500;
                            background: #f8fafc;
                            color: #64748b;
                            border: 1px solid #e2e8f0;
                            &.linked {
                                background: #eff6ff;
                                color: #3b82f6;
                                border: 1px solid #bfdbfe;
                            }
                        }
                    }
                }
                .card-more {
                    .more-icon {
                        font-size: 1rem;
                        color: #94a3b8;
                        cursor: pointer;
                        padding: 3px;
                    }
                }
                .card-amount {
                    display: flex;
                    align-items: baseline;
                    margin-bottom: 3px;
                    .currency {
                        font-size: 0.95rem;
                        font-weight: 500;
                        color: #94a3b8;
                        margin-right: 1px;
                    }
                    .num {
                        font-size: 1.5rem;
                        font-weight: 700;
                        color: #1e293b;
                        letter-spacing: -0.3px;
                        font-variant-numeric: tabular-nums;
                        line-height: 1.15;
                    }
                }
                .card-remark {
                    font-size: 0.78rem;
                    color: #64748b;
                    line-height: 1.45;
                    margin-bottom: 10px;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    min-height: 2.2rem;
                    &.empty {
                        color: #cbd5e0;
                        font-style: italic;
                        min-height: auto;
                        margin-bottom: 12px;
                    }
                }
                .card-foot {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-top: 9px;
                    border-top: 1px solid #f1f5f9;
                    .foot-user {
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        .user-avatar {
                            width: 22px;
                            height: 22px;
                            border-radius: 50%;
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 0.66rem;
                            font-weight: 600;
                            color: #fff;
                            background: #0440c3;
                        }
                        .user-name {
                            font-size: 0.78rem;
                            color: #475569;
                            font-weight: 500;
                        }
                    }
                    .foot-date {
                        display: flex;
                        align-items: center;
                        gap: 3px;
                        font-size: 0.72rem;
                        color: #94a3b8;
                        i { font-size: 0.74rem; }
                    }
                }
            }
        }
    }
    .empty-wrap {
        padding-top: 20vh;
        text-align: center;
        > img {
            width: 300px;
        }
    }
    .pagination-container {
        display: none;
    }
    .load-text {
        padding: 1rem 0;
        text-align: center;
        color: #999;
    }
}
.content-page {
    color: $primary-font-color;
}
/* ========== 导入弹窗 - C端风格 ========== */
::v-deep .import-dialog {
    border-radius: 20px !important;
    overflow: hidden;
    .el-dialog__body {
        padding: 0;
    }
    .import-content {
        background: linear-gradient(180deg, #f8fafc 0%, #ffffff 280px);
        padding: 28px 32px 24px;
        /* ========== 头部 ========== */
        .import-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 28px;
            .import-title {
                display: flex;
                align-items: center;
                gap: 14px;
                .title-icon {
                    width: 48px;
                    height: 48px;
                    border-radius: 14px;
                    background: linear-gradient(135deg, #4299e1 0%, #0440c3 100%);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 6px 16px rgba(4, 64, 195, 0.25);
                    i {
                        font-size: 22px;
                        color: #fff;
                    }
                }
                .title-main {
                    font-size: 1.2rem;
                    font-weight: 700;
                    color: #1a202c;
                    line-height: 1.2;
                }
                .title-sub {
                    font-size: 0.8rem;
                    color: #8a94a6;
                    margin-top: 4px;
                }
            }
            .dialog-close {
                font-size: 1.2rem;
                color: #a0aec0;
                cursor: pointer;
                padding: 6px;
                border-radius: 8px;
                transition: all 0.2s;
                &:hover { color: #0440c3; background: #ebf2ff; }
            }
        }
        /* ========== 步骤 ========== */
        .import-step {
            margin-bottom: 20px;
            .step-head {
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 14px;
                .step-num {
                    width: 26px;
                    height: 26px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, #4299e1 0%, #0440c3 100%);
                    color: #fff;
                    font-size: 0.82rem;
                    font-weight: 700;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 3px 8px rgba(4, 64, 195, 0.2);
                }
                .step-label {
                    font-size: 0.95rem;
                    font-weight: 600;
                    color: #2d3748;
                }
                .step-desc {
                    font-size: 0.75rem;
                    color: #a0aec0;
                }
            }
        }
        /* 模板卡片 */
        .template-card {
            display: flex;
            align-items: center;
            gap: 14px;
            padding: 16px 18px;
            background: #fff;
            border: 1.5px solid #e2e8f0;
            border-radius: 14px;
            cursor: pointer;
            transition: all 0.25s;
            &:hover {
                border-color: #0440c3;
                background: #f8fbff;
                transform: translateY(-2px);
                box-shadow: 0 8px 20px rgba(4, 64, 195, 0.1);
            }
            .template-icon {
                width: 46px;
                height: 46px;
                border-radius: 12px;
                background: linear-gradient(135deg, #2ecc71 0%, #27ae60 100%);
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                i {
                    font-size: 22px;
                    color: #fff;
                }
            }
            .template-info {
                flex: 1;
                .template-name {
                    font-size: 0.9rem;
                    font-weight: 600;
                    color: #2d3748;
                    margin-bottom: 4px;
                }
                .template-meta {
                    display: flex;
                    gap: 14px;
                    font-size: 0.72rem;
                    color: #a0aec0;
                    span {
                        display: flex;
                        align-items: center;
                        gap: 3px;
                        i { font-size: 0.72rem; }
                    }
                }
            }
            .template-action {
                display: flex;
                align-items: center;
                gap: 5px;
                padding: 7px 14px;
                background: linear-gradient(135deg, #4299e1 0%, #0440c3 100%);
                border-radius: 8px;
                color: #fff;
                font-size: 0.82rem;
                font-weight: 500;
                box-shadow: 0 3px 8px rgba(4, 64, 195, 0.25);
                i { font-size: 0.85rem; }
            }
        }
        /* 步骤分割线 */
        .step-divider {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
            margin: 4px 0 20px;
            .divider-ornament {
                width: 40px;
                height: 1px;
                background: linear-gradient(90deg, transparent 0%, #cbd5e0 100%);
                &:last-child {
                    background: linear-gradient(90deg, #cbd5e0 0%, transparent 100%);
                }
            }
            .divider-text {
                font-size: 0.72rem;
                color: #a0aec0;
            }
        }
        /* ========== 上传区 ========== */
        .upload-dragger-wrap {
            width: 100%;
            .el-upload-dragger {
                border: none !important;
                background: transparent !important;
                padding: 0 !important;
            }
            .upload-zone {
                padding: 32px 24px;
                background: #fff;
                border: 2px dashed #cbd5e0;
                border-radius: 16px;
                text-align: center;
                transition: all 0.25s;
                cursor: pointer;
                &:hover {
                    border-color: #4299e1;
                    background: #f5faff;
                }
                .upload-icon-wrap {
                    position: relative;
                    width: 64px;
                    height: 64px;
                    margin: 0 auto 14px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .upload-icon {
                        position: relative;
                        z-index: 2;
                        font-size: 34px;
                        color: #4299e1;
                    }
                    .upload-icon-glow {
                        position: absolute;
                        inset: 0;
                        border-radius: 50%;
                        background: radial-gradient(circle, rgba(66,153,225,0.18) 0%, transparent 70%);
                    }
                }
                .upload-text {
                    font-size: 0.92rem;
                    color: #718096;
                    margin-bottom: 4px;
                    .upload-link {
                        color: #0440c3;
                        font-weight: 600;
                        text-decoration: underline;
                        margin-left: 2px;
                    }
                    .upload-success-icon {
                        font-size: 1.1rem;
                        color: #48bb78;
                        margin-right: 4px;
                    }
                    .upload-success-text {
                        color: #276749;
                        font-weight: 600;
                    }
                }
                .upload-name {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    margin-top: 10px;
                    padding: 6px 10px 6px 14px;
                    background: linear-gradient(135deg, #f0fff4 0%, #ebf8ff 100%);
                    border: 1px solid #c6f6d5;
                    border-radius: 10px;
                    font-size: 0.82rem;
                    color: #2d3748;
                    font-weight: 500;
                    max-width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    .upload-remove {
                        color: #a0aec0;
                        font-size: 0.8rem;
                        padding: 2px;
                        border-radius: 50%;
                        cursor: pointer;
                        transition: all 0.15s;
                        &:hover {
                            background: #f56565;
                            color: #fff;
                        }
                    }
                }
                .upload-tip {
                    margin-top: 14px;
                    font-size: 0.76rem;
                    color: #a0aec0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 5px;
                    i {
                        color: #ecc94b;
                        font-size: 0.85rem;
                    }
                    b {
                        color: #718096;
                        font-weight: 600;
                    }
                }
            }
        }
        /* ========== 注意事项 ========== */
        .import-notice {
            display: flex;
            align-items: flex-start;
            gap: 10px;
            padding: 12px 16px;
            background: linear-gradient(135deg, #fffaf0 0%, #fff5f5 100%);
            border-radius: 12px;
            margin: 22px 0 0;
            font-size: 0.8rem;
            color: #7a6300;
            line-height: 1.6;
            i {
                color: #ecc94b;
                font-size: 1rem;
                flex-shrink: 0;
                margin-top: 1px;
            }
            b {
                color: #c05621;
            }
        }
        /* ========== 底部按钮 ========== */
        .import-footer {
            display: flex;
            justify-content: flex-end;
            gap: 12px;
            margin-top: 24px;
            padding-top: 20px;
            border-top: 1px solid #f1f3f5;
            .footer-btn {
                height: 40px;
                min-width: 110px;
                padding: 0 22px;
                border-radius: 10px;
                font-size: 0.88rem;
                font-weight: 600;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 6px;
                cursor: pointer;
                transition: all 0.2s;
                &.cancel-btn {
                    background: #f7fafc;
                    color: #4a5568;
                    border: 1px solid #e2e8f0;
                    &:hover {
                        background: #edf2f7;
                        color: #2d3748;
                    }
                }
                &.confirm-btn {
                    background: linear-gradient(135deg, #4299e1 0%, #0440c3 100%);
                    color: #fff;
                    box-shadow: 0 4px 12px rgba(4, 64, 195, 0.25);
                    &:hover:not(.disabled) {
                        transform: translateY(-1px);
                        box-shadow: 0 6px 16px rgba(4, 64, 195, 0.35);
                    }
                    &.disabled {
                        background: #cbd5e0;
                        box-shadow: none;
                        cursor: not-allowed;
                    }
                    &.loading {
                        opacity: 0.85;
                        cursor: progress;
                    }
                }
            }
        }
    }
}
/* ========== 导入弹窗 - 移动端适配 ========== */
@media (max-width: 768px) {
    ::v-deep .import-dialog {
        width: 94% !important;
        .import-content {
            padding: 22px 18px 18px !important;
            .import-header .title-sub { display: none; }
            .template-card {
                padding: 12px 14px;
                .template-action { padding: 6px 10px; font-size: 0.76rem; }
            }
            .upload-dragger-wrap .upload-zone { padding: 24px 16px; }
        }
    }
}
.del-li {
    color: $error-font-color !important;
}
.corner-operation {
    list-style: none;
    margin: 0;
    padding: 4px 0;
    text-align: left;
    min-width: 90px;
    li {
        padding: 7px 14px;
        cursor: pointer;
        color: #4a5568;
        font-size: 0.88rem;
        display: flex;
        align-items: center;
        gap: 6px;
        i { font-size: 0.88rem; }
        &:hover {
            background-color: #f7fafc;
            color: $primary-btn-color;
        }
    }
}
</style>
